import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { BaseSiteService, CmsService, LanguageService, OccEndpointsService, ProductService, RoutingService } from "@spartacus/core";
import { Subscription } from "rxjs";
import { take } from "rxjs/operators";
import { CustomProfileAndPreferencesService } from "src/app/custom-profile-and-preferences/custom-profile-and-preferences.service";
import { CheckoutService } from "src/app/shared/modules/checkout/checkout.service";
import { FutureCartComponent } from "src/app/shared/modules/future-cart/future-cart.component";
import { SharedService } from "src/app/shared/services/shared.service";
import { AccountOverviewService, OfferBanner } from "../../account-overview.service";
import { MyAccOverviewMarketingNbaBannerComponent } from "../my-acc-overview-marketing-nba-banner/my-acc-overview-marketing-nba-banner.component";
import { MyAccOverviewSaveOrderBannerComponent } from "../my-acc-overview-save-order-banner/my-acc-overview-save-order-banner.component";

@Component({
    selector: 'app-acc-overview-placeholder1',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './acc-overview-placeholder1.component.html',
    styleUrls: ['./acc-overview-placeholder1.component.scss'],
    standalone: false
})
export class AccOverviewPlaceholder1Component implements OnInit, OnDestroy {
  @ViewChild(MyAccOverviewMarketingNbaBannerComponent, { static: false }) marketingNbaBanner: MyAccOverviewMarketingNbaBannerComponent;
  @ViewChild(MyAccOverviewSaveOrderBannerComponent, { static: false }) saveOrderBanner: MyAccOverviewSaveOrderBannerComponent;

  accountNumber: string = null;
  compNameAdBanner = 'SanofiAccountOverviewBannerComponent4';
  compNameAdBanner2 = 'SanofiAccountOverviewBannerComponent2';
  compNameAdBanner3 = 'SanofiAccountOverviewBannerComponent3';
  compNameAdBanner6 = 'SanofiAccountOverviewBannerComponent6';
  compNameAdBanner1 = 'SanofiAccountOverviewBannerComponent';
  cmsResponse: any;
  productCodes: any;
  prodcutsInfo: any = [];
  prodDocs: any = [];
  prodDocus: any = [];
  fluResevartion: boolean;
  isSelectedMultipleLoc = false;
  isFutureshipUser = false;
  futureShipContent: any;
  baseSiteId = '';
  eventEmitSub: Subscription;
  userAccountDataSub: Subscription;
  punchOutKey: boolean;
  futureShipContent2 = {};
  banners: OfferBanner[] = [];

  constructor(
    private readonly acService: AccountOverviewService,
    private readonly cdr: ChangeDetectorRef,
    private readonly router: RoutingService,
    private readonly cmsData: CmsService,
    protected productService: ProductService,
    private readonly checkoutService: CheckoutService,
    private readonly lang: LanguageService,
    private readonly modal: NgbModal,
    private readonly sharedService: SharedService,
    private readonly baseSiteService: BaseSiteService,
    private readonly pfService: CustomProfileAndPreferencesService,
    private readonly occEndPointService: OccEndpointsService
  ) { }

  ngOnInit(): void {
    if (localStorage.getItem('punchout-sid-key') != null) {
      this.punchOutKey = true;
    }
    this.lang.getActive().subscribe((res) => {
      if (res) {
        this.prodcutsInfo = [];
      }
    });
    this.acService.userAccountIdDetailsData.subscribe((res) => {
      if (this.accountNumber === null) {
        this.accountNumber = res.defaultB2BUnit.uid;
        this.cdr.detectChanges();
      }
    });

    const url = this.occEndPointService.getBaseUrl({
      baseUrl: true,
      prefix: false,
      baseSite: false,
    });

    this.cmsData
      .getComponentData('AccountFutureShipPromotionalBannerComponent')
      .subscribe((res) => {
        let cmsRes = res;
        this.futureShipContent = cmsRes['futureShipProductNames'];
      });

    this.cmsData.getComponentData('SanofiAccountOverviewBannerComponent2').subscribe(res => {
      if (res) {
        this.futureShipContent2['url'] = url + res['media']['url'];
        this.futureShipContent2['altText'] = res['media'].altText;
        this.futureShipContent2['downloadUrl'] = res['urlLink'] || 'javascript:void(0)';
      }
    });

    this.eventEmitSub = this.pfService.futureShipFlagEmitted.subscribe((res: boolean) => {
      this.isFutureshipUser = res;
      this.cdr.detectChanges();
    });
    this.baseSiteService
      .getActive()
      .pipe(take(1))
      .subscribe((res) => (this.baseSiteId = res));

    this.userAccountDataSub = this.pfService._userAccountData.subscribe((userData) => {
      if (userData) {
        const b2bUid = userData?.defaultB2BUnit?.uid;
        this.acService.getOfferEligibility(userData?.userName, b2bUid);
        this.acService.getOfferBanners(userData?.userName, b2bUid);

        // subscribe separately to the BehaviorSubject
        this.acService.offerBanners$.subscribe(res => {
          if (res) {
            this.banners = res.banners;
            this.cdr.detectChanges();
          }
        });
      }
    });
  }

  navigateToAccountDetails() {
    this.router.goByUrl('/my-account/profile');
    this.checkoutService.tabSelection('Account information');
  }

  openFutureShipmentModal() {
    if (!sessionStorage.getItem('selectedLocations')) {
      this.isSelectedMultipleLoc = true;
    } else if (JSON.parse(sessionStorage.getItem('selectedLocations'))?.length === 1) {
      this.isSelectedMultipleLoc = false;
    } else if (JSON.parse(sessionStorage.getItem('selectedLocations'))?.length > 1) {
      this.isSelectedMultipleLoc = true;
    }

    if (this.sharedService.getLocalStorage('eligibleContract')) {
      let modalRef = this.modal.open(FutureCartComponent, {
        centered: false,
        backdrop: 'static',
        windowClass:
          this.isSelectedMultipleLoc === true
            ? `MultiLocationModal ${this.baseSiteId}`
            : `FutureCartModal ${this.baseSiteId}`,
      });
    }
  }

  ngOnDestroy() {
    this.eventEmitSub?.unsubscribe();
    this.userAccountDataSub?.unsubscribe();
  }
}
